const dark = {
  id: 'dark',
  displayName: 'Dark',
  baseType: 'dark',
  enabled: true,
  linkedPalette: null,
  ui: {
    headerBg: '#000000', headerText: '#FFFFFF', accentColor: '#B2C2C2',
    mainBg: '#B2C2C2', mainText: '#000000', mainTextHeading: '#16213e',
    mainHeroText: '#FFFFFF', footerBg: '#000000', footerText: '#888888',
    cardBg: '#1a1a1a', cardText: '#d4d4d4', cardBorder: '#666666',
    cardButtonBg: '#0d6efd', cardButtonText: '#FFFFFF',
    navLinkText: '#FFFFFF', navLinkHover: '#0d6efd', navLinkActive: '#F5A623',
    listGroupBg: '#1a1a1a', bmrkDetailBg: '#000000',
    bmrkMetricBg: '#000000', bmrkMetricText: 'lightgray', bmrkMetricBorder: 'dimgray',
    mainCardText: '#d4d4d4', navLinkFocus: 'lightgray', navEmailActive: '#FFFFFF',
    homeProseLabel: '#000000', homeProseLink: '#0f3460', homeProseDlBtn: '#0f3460',
    cardButtonBorder: '#000000', linkColor: '#F5A623',
    cardHeaderBg: '#000000', cardHeaderText: '#F5A623',
    cardTextMuted: '#999999',
  },
};
export default dark;
